import { lazy } from 'react';
import Splash from '../pages/Splash';
import Home from '../features/home/pages/HomePage';
import AllCategoriesPage from "../features/home/pages/AllCategoriesPage";
import AddNewAddressPage from "../features/addresses/pages/AddNewAddressPage";
import UserProfilePage from "../features/profile/pages/UserProfilePage";
import OrdersList from "../features/orders/pages/OrdersList";
import OrderProfile from "../features/orders/pages/OrderProfile";
import ContentPage from "../features/profile/pages/ContentPage";
import ManageAddressesPage from "../features/addresses/pages/ManageAddressesPage";
import EditAddressPage from "../features/addresses/pages/EditAddressPage";
import WalletPage from "../features/profile/pages/WalletPage";
import InviteOthersPage from "../features/profile/pages/InviteOthersPage";
import ReagentsPage from "../features/profile/pages/ReagentsPage";
import SearchPage from "../features/home/pages/SearchPage";
import EditProfilePage from "../features/profile/pages/EditProfilePage";
import AllBrandsPage from "../features/home/pages/AllBrandsPage";
import ContactPage from "../features/profile/pages/ContactPage";
import FavoriteProductsPage from "../features/products/pages/FavoriteProductsPage";
import ProductReviewsPage from "../features/products/pages/ProductReviewsPage";
import NeedLogin from "../layouts/NeedLogin";
import StoreTicketPage from "../features/orders/pages/StoreTicketPage";
import TicketsListPage from "../features/orders/pages/TicketsListPage";
import TicketDetailsPage from "../features/orders/pages/TicketDetailsPage";
import ProducersPage from "../features/profile/pages/ProducersPage";
import ProducerProfilePage from "../features/profile/pages/ProducerProfilePage";
import ContractorsPage from "../features/profile/pages/ContractorsPage";
import ProducerAllProductsPage from "../features/profile/pages/ProducerAllProductsPage";
import CallsListPage from "../features/orders/pages/CallsListPage";


// صفحات کم‌مصرف (با lazy)
const LoginPage = lazy(() => import('../features/auth/pages/LoginPage'));
const VerifyPage = lazy(() => import('../features/auth/pages/VerifyPage'));
const RegisterPage = lazy(() => import('../features/auth/pages/RegisterPage'));
const ProductsList = lazy(() => import('../features/products/pages/ProductsListPage'));
const ProductProfilePage = lazy(() => import("../features/products/pages/ProductProfilePage"));
const ShoppingCartPage = lazy(() => import("../features/orders/pages/ShoppingCartPage"));
const SelectCityPage = lazy(() => import("../features/home/pages/SelectCityPage"));



const appRoutes = [
    {
        pageId : 0,
        path: "/",
        title: 'خوش آمدید',
        component: <Splash />,
    },
    {
        pageId: 1,
        path: '/login',
        title: 'ورود به سامانه',
        component: <LoginPage />,
    },
    {
        pageId: 2,
        path: '/verify',
        title: 'تایید شماره موبایل',
        component: <VerifyPage />,
    },
    {
        pageId: 3,
        path: '/register',
        title: 'ثبت نام اولیه',
        component: <RegisterPage />,
    },
    {
        pageId: 4,
        path: '/home',
        title: 'خانه',
        component: <Home />,
    },
    {
        pageId: 5,
        path: "/categories/:id?",
        title: 'دسته بندی ها',
        component: <AllCategoriesPage />,
    },
    {
        pageId: 6,
        path: "/products/:id?",
        title: 'لیست محصولات',
        component: <ProductsList />,
    },
    {
        pageId: 7,
        path: "/product/:id",
        title: 'پروفایل محصول',
        component: <ProductProfilePage />,
    },
    {
        pageId: 8,
        path: "/cart",
        title: 'سبد خرید',
        component: <ShoppingCartPage />,
    },
    {
        pageId: 9,
        path: "/add-address",
        title: 'افزودن آدرس',
        component: <AddNewAddressPage />,
    },
    {
        pageId: 10,
        path: "/profile",
        title: 'حساب کاربری',
        component: <UserProfilePage />,
    },
    {
        pageId: 11,
        path: "/orders",
        title: 'لیست سفارش ها',
        component: <OrdersList />,
    },
    {
        pageId: 12,
        path: "/orders/:id",
        title: 'اطلاعات سفارش',
        component: <OrderProfile />,
    },
    {
        pageId : 13,
        path: "/contents/:slug",
        title: 'نمایش محتوی ',
        component: <ContentPage />,
    },
    {
        pageId : 14,
        path: "/addresses",
        title: ' مدیریت آدرس ها ',
        component: <ManageAddressesPage />,
    },
    {
        pageId : 15,
        path: "/edit-address/:id",
        title: ' مدیریت آدرس ها ',
        component: <EditAddressPage />,
    },
    {
        pageId : 16,
        path: "/wallet",
        title: ' مدیریت کیف پول ',
        component: <WalletPage />,
    },
    {
        pageId : 17,
        path: "/profile/invite-others",
        title: ' دعوت دیگران   ',
        component: <InviteOthersPage />,
    },
    {
        pageId : 18,
        path: "/reagents",
        title: 'افراد معرفی شده',
        component: <ReagentsPage />,
    },
    {
        pageId : 19,
        path: "/search",
        title: 'جستجوی محصولات',
        component: <SearchPage />,
    },
    {
        pageId : 20,
        path: "/edit-profile",
        title: ' ویرایش پروفایل',
        component: <EditProfilePage />,
    },
    {
        pageId : 21,
        path: "/brands",
        title: 'لیست برندها',
        component: <AllBrandsPage />,
    },
    {
        pageId : 22,
        path: "/contact",
        title: 'اطلاعات تماس ',
        component: <ContactPage />,
    },
    {
        pageId : 23,
        path: "/favorites",
        title: 'محصولات موردعلاقه ',
        component: <FavoriteProductsPage />,
    },
    {
        pageId : 24,
        path: "/product/:id/reviews",
        title: 'نظرات محصول ',
        component: <ProductReviewsPage />,
    },
    {
        pageId : 25,
        path: "/select-city",
        title: 'انتخاب شهر پیش فرض ',
        component: <SelectCityPage />,
    },
    {
        pageId : 26,
        path: "/unauthorize",
        title: 'نیاز به احراز هویت ',
        component: <NeedLogin />,
    },
    {
        pageId : 26,
        path: "/factor-store/:id",
        title: 'درخواست پیش فاکتور ',
        component: <StoreTicketPage />,
    },

    {
        pageId: 27,
        path: "/factors",
        title: '  درخواست های پیش فاکتورها ',
        component: <TicketsListPage />,
    },
    {
        pageId: 28,
        path: "/factors/:id",
        title: 'اطلاعات پیش فاکتور',
        component: <TicketDetailsPage />,
    },
    {
        pageId: 29,
        path: "/producers",
        title: 'لیست تولیدکنندگان',
        component: <ProducersPage />,
    },
    {
        pageId: 30,
        path: "/producer/:id",
        title: 'اطلاعات تولیدکننده',
        component: <ProducerProfilePage />,
    },

    {
        pageId: 31,
        path: "/contractors",
        title: 'لیست پیمانکاران',
        component: <ContractorsPage />,
    },

    {
        pageId: 32,
        path: "/producer-products/:id",
        title: 'لیست محصولات تولیدکننده',
        component: <ProducerAllProductsPage />,
    },

    {
        pageId: 33,
        path: "/calls",
        title: 'لیست تماس ها',
        component: <CallsListPage />,
    },

];
export default appRoutes;
